const localStorageKey = 'loggedIn'
const tokenExpiryKey = 'tokenExpiry'

export default {
  isUserLoggedIn: () => {
    let isAuthenticated = false

    if (Date.now() < localStorage.getItem(tokenExpiryKey) &&
    localStorage.getItem(localStorageKey) === 'true') {
      isAuthenticated = true
    } else { isAuthenticated = false }

    return localStorage.getItem('userInfo') && isAuthenticated
  }
}
